import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { CommonModule } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { ButtonComponent } from '../../../../../../shared/components/button/button.component';
import { TelephoneLinkComponent } from '../../../../../../shared/components/telephone-link/telephone-link.component';
import { RadioButtonComponent } from '../../../../../../shared/components/forms/radio-button/radio-button.component';
import { FormsModule } from '@angular/forms';

type BookingDialogState = 'cancelComplete' | 'cancelError';

type CancelBookingOptions = {
  state: BookingDialogState;
};

@Component({
  selector: 'app-cancel-booking',
  imports: [ButtonComponent, CommonModule, TelephoneLinkComponent, RadioButtonComponent, FormsModule],
  templateUrl: './cancel-booking.component.html',
  styleUrl: './cancel-booking.component.scss',
})
export class CancelBookingComponent implements OnInit {
  cancelReasons = [
    "I'd rather not say",
    'I fixed it with Smart-Fix Hub',
    "I've replaced the product",
    'I need help with a different issue',
    'Other',
  ];

  selectedCancelReason = undefined;

  showPleaseSelectOptionError = false;
  constructor(
    @Inject(DIALOG_DATA) public data: CancelBookingOptions,
    public dialogRef: DialogRef<boolean>
  ) {}

  ngOnInit(): void {
    this.shuffle(this.cancelReasons);
  }

  shuffle(array: string[]): void {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  cancelBooking(): void {
    if (this.selectedCancelReason === undefined) {
      this.showPleaseSelectOptionError = true;
      return;
    }

    this.dialogRef.close(this.selectedCancelReason);
    this.dialogRef.close(true);
  }
}
